import { useGSAP } from "@gsap/react";
import * as styles from "./about-us-parallax.module.scss";
import React, { useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const AboutUsParallax = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const images: HTMLDivElement[] = gsap.utils.toArray(
        `.${styles.book__imgsEl}`,
        containerRef.current
      );

      images.forEach((el) => {
        const parallaxValue = parseFloat(
          getComputedStyle(el).getPropertyValue("--gsap-parallax") || "50"
        );

        gsap.to(el, {
          y: `-${parallaxValue}px`,
          ease: "none",
          scrollTrigger: {
            trigger: el.closest(`.${styles.book__imgsItem}`),
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
          },
        });
      });
    },
    { dependencies: [], scope: containerRef }
  );
  // Number of book images (update if more are added)
  const bookImages = [1, 2, 3, 4, 5, 6, 7];

  return (
    <section className={styles.page_about}>
      <div className={styles.book} ref={containerRef}>
        <div className={styles.book__wrapp}>
          <div className={styles.book__imgs}>
            {bookImages.map((num) => (
              <div
                key={num}
                className={`${styles.book__imgsItem} ${
                  styles[`book__imgs${num}`]
                }`}
              >
                <div className={styles.book__imgsEl}>
                  <img
                    src={`/images/about-us/book/book${num}.jpg`}
                    alt={`Book ${num}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
